// @ts-nocheck
// Vuex module の段階的 TypeScript 化（まずはファイル移管。詳細な型は後続対応）
const state = {
  judgeSettingErrors: [],
}

const mutations = {
  setJudgeSettingErrors(state, errors) {
    state.judgeSettingErrors = errors
  },
}

const getters = {
  getJudgeSettingErrors(state) {
    return state.judgeSettingErrors
  },
  isValidJudgeSetting(state) {
    return state.judgeSettingErrors.flat().length === 0
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
